import type { PersistedAppointment } from "schemas";
import { useLiteSiteStore } from "../store";

export const setAppointment = (appointment: PersistedAppointment) => {
  useLiteSiteStore.setState((state) => ({
    appointments: state.appointments.set(appointment.id, appointment),
  }));
};
